import React from "react";
import {useTranslation} from "react-i18next";


const FilkersError = () => {
    const {t} = useTranslation("virtualWindow");
    return (

        <div className="flk-error align-content-center">

            <div className="d-flex justify-content-center">
                <img alt="error" width="200"
                     src="https://cdn.filkers.com/static/img/mascot/404-1E0E1C.svg"/>
            </div>

            <div className="d-flex justify-content-center">
                <br/>
                <h1>{t(`error.line1`)}</h1>
                <br/>
            </div>
            <div className="d-flex justify-content-center">
                <br/>
                <h4>{t(`error.line2`)}</h4>
                <br/>
            </div>

        </div>

    );

}

export default FilkersError;
